/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Run_Retry_OfInputs */



/**
* | output |
* | --- |
* | "Retry of an earlier run" |
*
* @param {Agent_Run_Retry_OfInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_retry_of = /** @type {((inputs?: Agent_Run_Retry_OfInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Retry_OfInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiederholung eines früheren Laufs")
	return /** @type {LocalizedString} */ ("Retry of an earlier run")
});